<template>
  <div id="top">
    <div
      style="font-size:30px;text-align:center;padding:30px 0;border-bottom:1px solid #DDDDDD;background-color:#fff;text-align:center"
    >
      <img :src="serve + '/images/top.png'" style="width:300px;display:inline-block">
    </div>
    <div class="topMenu" :class="fixed?'fixed':''">
      <div class="container clear">
        <div class="clear-item" :class="menuId==1?'active':''" @click="menuId=1">
          <div class="icon">
            <i class="fas fa-bong fa-3x"></i>
          </div>
          <div>耗材器具</div>
        </div>
        <div class="clear-item" :class="menuId==2?'active':''" @click="menuId=2">
          <div class="icon">
            <i class="fas fa-flask fa-3x"></i>
          </div>
          <div>实验办公</div>
        </div>
        <div class="clear-item" :class="menuId==3?'active':''" @click="menuId=3">
          <div class="icon">
            <i class="fas fa-vial fa-3x"></i>
          </div>
          <div>试剂生化</div>
        </div>
        <div class="clear-item" :class="menuId==4?'active':''" @click="menuId=4">
          <div class="icon">
            <i class="fab fa-hubspot fa-3x"></i>
          </div>
          <div>抗体WB</div>
        </div>
        <div class="clear-item" :class="menuId==5?'active':''" @click="menuId=5">
          <div class="icon">
            <i class="fas fa-microscope fa-3x"></i>
          </div>
          <div>设备仪器</div>
        </div>
        <div class="clear-item" :class="menuId==6?'active':''" @click="menuId=6">
          <div class="icon">
            <i class="fas fa-frog fa-3x"></i>
          </div>
          <div>实验动物</div>
        </div>
        <div class="clear-item" :class="menuId==7?'active':''" @click="menuId=7">
          <div class="icon">
            <i class="fas fa-tools fa-3x"></i>
          </div>
          <div>技术服务</div>
        </div>
        <div class="clear-item" :class="menuId==8?'active':''" @click="menuId=8">
          <div class="icon">
            <i class="fas fa-filter fa-3x"></i>
          </div>
          <div>洁净装置</div>
        </div>
        <div class="clear-item" :class="menuId==9?'active':''" @click="menuId=9">
          <div class="icon">
            <i class="fas fa-laptop fa-3x"></i>
          </div>
          <div>生物软件</div>
        </div>
        <div class="clear-item" :class="menuId==10?'active':''" @click="menuId=10">
          <div class="icon">
            <i class="fas fa-book fa-3x"></i>
          </div>
          <div>书城医学</div>
        </div>
        <div class="clear-item" :class="menuId==11?'active':''" @click="menuId=11">
          <div class="icon">
            <i class="fas fa-pills fa-3x"></i>
          </div>
          <div>生物制药</div>
        </div>
      </div>
    </div>

    <div class="container">
      <div>
        <div class="title">
          <span style="margin-right:5px">
            <i class="fas fa-fire-alt fa-lg"></i>
          </span>
          <span style="line-height:46px;font-size:20px;margin-right:10px">热销榜</span>
          <span>实时热销 一榜打尽</span>
          <span style="float:right;display:inline-block;line-height:48px;margin-right:30px;">
            <span style="margin-right:5px">
              <i class="far fa-clock fa-lg"></i>
            </span>
            下次更新{{hours}}小时{{minutes}}分钟
          </span>
        </div>

        <div style="margin-top:10px;" class="topList" v-if="data">
          <div class="clear">
            <div class="clear-item" v-for="(item,index) of data.hot_sell" :key="index">
              <router-link :to="'/product/'+item.id">
                <el-card shadow="hover">
                  <div style="margin-bottom: 10px;">
                    <span
                      class="index"
                      :class="[index>2?'color2':'',index==0?'color1':'',index==1?'color3':'',index==2?'color4':'']"
                    >{{index+1}}</span>
                    <span
                      class="tg2"
                      v-if="index<3"
                      :class="[index==0?'border1':'',index==1?'border2':'',index==2?'border3':'']"
                    >热卖指数{{100-index}}</span>
                  </div>
                  <div>
                    <img :src="serve  +item.images" style="width:100%">
                  </div>
                  <div>
                    <span class="tg1">自营</span>
                  </div>
                  <div class="t">{{item.title}}</div>
                </el-card>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="title">
          <span style="margin-right:5px">
            <i class="fas fa-fire-alt fa-lg"></i>
          </span>
          <span style="line-height:46px;font-size:20px;margin-right:10px">热搜榜</span>
          <span>网络世界搜索热门</span>
          <span style="float:right;display:inline-block;line-height:48px;margin-right:30px;">
            <span style="margin-right:5px">
              <i class="far fa-clock fa-lg"></i>
            </span>
            下次更新{{hours}}小时{{minutes}}分钟
          </span>
        </div>

        <div style="margin-top:10px;" class="topList" v-if="data">
          <div class="clear">
            <div class="clear-item" v-for="(item,index) of data.hot_views" :key="index">
              <router-link :to="'/product/'+item.id">
                <el-card shadow="hover">
                  <div style="margin-bottom: 10px;">
                    <span
                      class="index"
                      :class="[index>2?'color2':'',index==0?'color1':'',index==1?'color3':'',index==2?'color4':'']"
                    >{{index+1}}</span>
                    <span
                      class="tg2"
                      v-if="index<3"
                      :class="[index==0?'border1':'',index==1?'border2':'',index==2?'border3':'']"
                    >热卖指数{{100-index}}</span>
                  </div>
                  <div>
                    <img :src="serve  +item.images" style="width:100%">
                  </div>
                  <div>
                    <span class="tg1">自营</span>
                  </div>
                  <div class="t">{{item.title}}</div>
                </el-card>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="title">
          <span style="margin-right:5px">
            <i class="fas fa-fire-alt fa-lg"></i>
          </span>
          <span style="line-height:46px;font-size:20px;margin-right:10px">折扣榜</span>
          <span>低价折扣优惠全在这里</span>
          <span style="float:right;display:inline-block;line-height:48px;margin-right:30px;">
            <span style="margin-right:5px">
              <i class="far fa-clock fa-lg"></i>
            </span>
            下次更新{{hours}}小时{{minutes}}分钟
          </span>
        </div>

        <div style="margin-top:10px;" class="topList" v-if="data">
          <div class="clear">
            <div class="clear-item" v-for="(item,index) of data.discount" :key="index">
              <router-link :to="'/product/'+item.id">
                <el-card shadow="hover">
                  <div style="margin-bottom: 10px;">
                    <span
                      class="index"
                      :class="[index>2?'color2':'',index==0?'color1':'',index==1?'color3':'',index==2?'color4':'']"
                    >{{index+1}}</span>
                    <span
                      class="tg2"
                      v-if="index<3"
                      :class="[index==0?'border1':'',index==1?'border2':'',index==2?'border3':'']"
                    >热卖指数{{100-index}}</span>
                  </div>
                  <div>
                    <img :src="serve +item.images" style="width:100%">
                  </div>
                  <div>
                    <span class="tg1">自营</span>
                  </div>
                  <div class="t">{{item.title}}</div>
                </el-card>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      //
      isLogin: null,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      menuId: 1,
      data: null,
      hours: null,
      minutes: null,
      seconds: null,
      fixed: false,
      src: null,
      footer: ""
    };
  },

  created() {
    document.getElementsByClassName("search-bar");
    var that = this;
    var end = new Date(
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
    );
    var now = new Date().getTime();
    var distance = end - now;
    this.hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    setInterval(() => {
      var now = new Date().getTime();
      var distance = end - now;
      this.hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    }, 1000);
    this.axios
      .get(this.serve + "/isLogin", {
        params: {
          mobile: this.mobile,
          token: this.token
        }
      })
      .then(res => {
        if (res.data.data == 1) {
          this.$store.state.isLogin = true;
          this.isLogin = true;
        } else {
          this.$store.state.isLogin = false;
          this.isLogin = false;
        }
      });
    this.load();
    this.axios.get(this.serve + "/wxgzh_img").then(res => {
      this.src = res.data.data;
    });
    this.axios.get(this.serve + "/get_foot_brand").then(res => {
      this.footer = res.data;
    });
  },
  watch: {
    menuId: "load"
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 330) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
    },
    load() {
      this.axios
        .get(this.serve + "/bio_rank_list", {
          params: {
            class: this.menuId
          }
        })
        .then(res => {
          console.log(res)
          this.data = res.data;
        });
    },
    go1() {
      this.$router.push("/user/home");
    },
    logout() {
      this.$cookies.remove("token");
      this.$cookies.remove("user");
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss">
#top {
  .img1 {
    position: relative;
    top: 20px;
    margin-right: 10px;
  }
  .footer2 {
    .top {
      padding: 80px 0;
      border-bottom: 1px solid #ddd;
    }
    .label {
      text-align: center;
      color: #333;
      font-weight: bold;
      font-size: 23px;
      text-align: center;
    }
  }
  #footer {
    padding: 60px 0 0 0;
    .title2 {
      text-align: center;
      font-size: 19px;
      color: #999;
      margin-bottom: 20px;
    }

    .info {
      text-align: center;
      .brand {
        text-decoration: none;
        color: #999;
      }
      .brand:hover {
        color: #e2211c;
      }
      .brand.hvr-fade {
        display: inline;
      }
    }
    .phone {
      text-align: center;
      .ico {
        color: ccc;
        font-size: 20px;
        margin-right: 20px;
      }
      .number {
        font-size: 17px;
        font-weight: bold;
      }
    }
    .box {
      border: 1px solid #e8e8e8;
      height: 86px;
      width: 86px;
      margin: 0 auto;
      .ico {
        text-align: center;
        padding: 20px 0 10px 0;
        font-size: 25px;
      }
      .label {
        text-align: center;
        font-size: 13px;
      }
    }
    .box:hover {
      color: #e2211c;
      border: 1px solid #e2211c;
      cursor: pointer;
    }
    .hvr-fade {
      background-color: transparent;
    }
  }

  .el-dropdown-link {
    font-size: 12px;
    color: #999;
  }
  .el-input__inner {
    border-radius: 20px 0 0 20px;
  }
  .el-input-group__append {
    border-radius: 0 20px 20px 0;
  }
  font-family: "微软雅黑";
  font-size: 14px;
  .fixed {
    position: fixed;
    top: 0;
    z-index: 99;
    width: 100%;
  }
  .topList {
    .clear-item {
      .tg2 {
        font-size: 12px;
        border-radius: 0 10px 10px 0;

        height: 18px;
        line-height: 18px;
        padding: 0 5px;
        margin-left: -30px;
        display: inline-block;
      }
      .border1 {
        border: 1px solid #e2211c;
        color: #e2211c;
      }
      .border2 {
        border: 1px solid #fc8412;
        color: #fc8412;
      }
      .border3 {
        border: 1px solid #ffb535;
        color: #ffb535;
      }
      .color1 {
        background-color: #e2211c;
      }
      .color2 {
        background-color: #d3bf99;
      }
      .color3 {
        background-color: #fc8412;
      }
      .color4 {
        background-color: #ffb535;
      }

      .t {
        line-height: 1.5em;
        height: 43px;
        overflow: hidden;
      }
      .tg1 {
        color: #e2211c;
        border: 1px;
        font-size: 12px;
        border: 1px solid #e2211c;
        padding: 2px 5px;
        margin: 10px 0;
        display: inline-block;
      }
      .el-card {
        overflow: visible;
      }
      width: 220px;
      height: 340px;
      margin-bottom: 20px;
      margin-right: 20px;
      cursor: pointer;
      .index {
        border-radius: 3px 0 0 0;
        width: 35px;
        text-align: center;
        height: 20px;
        line-height: 20px;
        display: inline-block;
        color: #fff;
        position: relative;
        left: -28px;
      }
      .color1::before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        top: 20px;
        left: 0px;
        border-top: 8px solid #9a1828;
        border-left: 8px solid transparent;
      }
      .color2::before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        top: 20px;
        left: 0px;
        border-top: 8px solid #a98138;
        border-left: 8px solid transparent;
      }
      .color3::before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        top: 20px;
        left: 0px;
        border-top: 8px solid #a14314;
        border-left: 8px solid transparent;
      }
      .color4::before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        top: 20px;
        left: 0px;
        border-top: 8px solid #6d4a0e;
        border-left: 8px solid transparent;
      }
    }
  }
  .title {
    padding-left: 20px;
    height: 46px;
    background-color: #e2211c;
    color: #fff;
  }
  .topMenu {
    box-shadow: 0 17px 15px -5px #aaa;
    background-color: #fff;
    margin-bottom: 30px;
    .clear-item {
      width: 105px;
      text-align: center;
      height: 90px;
      border: 1px solid #fff;
      cursor: pointer;
    }
    .icon {
      margin: 15px 0 5px 0;
    }
    .clear-item.active {
      background-color: #e2211c;
      color: #fff !important;
      border: 1px solid #e2211c;
    }
    .clear-item:hover {
      border: 1px solid #e2211c;
      color: #e2211c;
    }
  }

  .cmd-words {
    color: #999;
    font-size: 12px;
    margin: 5px 10px;
  }
  .cmd-words:hover {
    text-decoration: underline;
  }
  background-color: rgb(245, 245, 245);

  .fa-times {
    cursor: pointer;
    color: #c0c4cc;
  }
  .fa-times:hover {
    color: #606266;
  }
  .l1 {
    margin-bottom: 10px;
  }
  .cover {
    display: block;
    height: 60px;
    width: 60px;
    border: 1px solid #ddd;
  }
  .m1 {
    transition: 0.3s;
  }
  .m1:hover {
    color: #8cbe29;
  }
  .cart {
    display: block;
    width: 150px;
  }
  .el-input-group__append {
    background-color: #e2211c;
    color: #fff;
    cursor: pointer;
  }
  .left-item {
    float: left;
    color: #666;
    svg {
      margin-right: 5px;
    }
  }
  .right-item {
    float: right;
    color: #999;
    padding: 0 10px;
  }
  .right-item2 {
    float: right;
    color: #999;
    padding: 0 10px;
  }
  .right-item:hover {
    text-decoration: underline;
    color: #777;
  }
  .float-item {
    line-height: 35px;
    font-size: 12px;
  }
}
</style>
